import {useIntl} from 'react-intl'
import {toast} from 'react-toastify'
import exportCsv from 'src/feature/bite/helpers/exportCsv'
import exportExcel from 'src/feature/bite/helpers/exportExcel'

interface Props {
  exportTable?: string
  exportAllExcel?: () => void
  exportAllCsv?: () => void
}

export default function ExportReportBtn({
  exportTable,
  exportAllExcel,
  exportAllCsv,
}: Props): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <button
        type='button'
        className='btn btn-light'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <i className='ki-duotone ki-exit-down fs-2'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {intl.formatMessage({id: 'GLOBAL.EXPORT'})}
      </button>
      <div
        id='kt_datatable_example_export_menu'
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 fw-semibold fs-7 w-250px py-4'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <span
            className='menu-link px-3'
            data-kt-export='excel'
            onClick={() => {
              exportExcel(exportTable)

              toast.success(intl.formatMessage({id: 'GLOBAL.EXPORT.SUCCESS'}))
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.EXPORT.EXCEL'})}
          </span>
        </div>
        <div className='menu-item px-3'>
          <span
            className='menu-link px-3'
            onClick={() => {
              exportCsv(exportTable || '')
              toast.success(intl.formatMessage({id: 'GLOBAL.EXPORT.SUCCESS'}))
            }}
          >
            {intl.formatMessage({id: 'GLOBAL.EXPORT.CSV'})}
          </span>
        </div>
        <div className='menu-item px-3'>
          <span className='menu-link px-3' onClick={() => exportAllExcel && exportAllExcel()}>
            {intl.formatMessage({id: 'GLOBAL.EXPORT.ALL.EXCEL'})}
          </span>
        </div>
        <div className='menu-item px-3'>
          <span className='menu-link px-3' onClick={() => exportAllCsv && exportAllCsv()}>
            {intl.formatMessage({id: 'GLOBAL.EXPORT.ALL.CSV'})}
          </span>
        </div>
      </div>
    </>
  )
}
